module.exports = __webpack_public_path__ + "static/media/og-logo.83d6e28c.svg";